export default "__VITE_ASSET__325AfkH8__"